import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['en', 'ru'],
  defaultLocale: 'en',
});

export const defaultTimezone = 'Europe/Moscow';

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);

export type Locale = (typeof routing)['locales'][number];

export function isValidLocale(locale: unknown): locale is Locale {
  return routing.locales.some((l) => l === locale);
}

export function getLocale(locale: string | null | undefined): Locale {
  return isValidLocale(locale) ? locale : routing.defaultLocale;
}

export function getPathnameWithoutLocale(pathname: string): string {
  return pathname.replace(new RegExp(`^/(?:${['en', 'ru'].join('|')})(?=$|/)`), '') || '/';
}
